import { useContext } from 'react';
import { InstantSearchSSRContext } from './InstantSearchSSRContext.js';

function useInstantSearchSSRContext() {
    return useContext(InstantSearchSSRContext);
}

export { useInstantSearchSSRContext };
